import { h } from '@stencil/core';
import isEmpty from 'lodash/isEmpty';
import { EQdsButtonSize, EQdsButtonImportance, ConfiguratorHandler } from '@pes-ui/utils';
import { CtaList } from '../../reusable/cta-list';
export class PesCtaAreaViewSticky {
  componentWillLoad() {
    if (!this.ctaInfo)
      return;
    const primaryCta = Object.entries(this.ctaInfo).find(([_, cta]) => cta.primary) || null;
    if (!primaryCta)
      return;
    const [ctaKey, ctaDetails] = primaryCta;
    this.itemCtas = [ctaKey];
    this.ctaInfo = { [ctaKey]: ctaDetails };
    this.ctaInfoMapping[ctaKey] = {
      importance: EQdsButtonImportance.EMPHASIZED,
      size: EQdsButtonSize.STANDARD,
    };
  }
  constructor() {
    var _a;
    this.unifiedCheckoutFlag = (_a = ConfiguratorHandler.getSingleConfig('FeatureFlags')) === null || _a === void 0 ? void 0 : _a.unifiedCheckout;
    this.isUnifiedCheckoutEnabled = ConfiguratorHandler.isFeatureFlagEnabled(this.unifiedCheckoutFlag || {});
    this.imageUrl = undefined;
    this.imageTitle = undefined;
    this.priceHTML = undefined;
    this.tooltipHTML = undefined;
    this.priceFromLabel = undefined;
    this.buttons = undefined;
    this.addToMyProductsLabel = undefined;
    this.removeFromMyProductsLabel = undefined;
    this.isInFavorites = false;
    this.showFavorites = undefined;
    this.selectorConfig = undefined;
    this.showProductSelectorStatus = undefined;
    this.ctaInfo = undefined;
    this.ctaInfoMapping = {};
    this.showCtas = undefined;
    this.itemCtas = undefined;
    this.handleCtaClick = undefined;
    this.productSelectorInfo = undefined;
    this.el.dir = document.documentElement.dir || 'auto';
  }
  renderButton() {
    const { emphasized } = this.buttons || {};
    const importance = emphasized ? EQdsButtonImportance.EMPHASIZED : EQdsButtonImportance.STANDARD;
    const { [EQdsButtonImportance.EMPHASIZED]: emphasizedProps, [EQdsButtonImportance.STANDARD]: standardProps, } = this.buttons || {};
    const props = emphasized ? emphasizedProps : standardProps === null || standardProps === void 0 ? void 0 : standardProps[0];
    if (isEmpty(props)) {
      return null;
    }
    const { buttonlabel, enableNewWidget } = this.selectorConfig || {};
    const { label, icon, dataset, onClick } = props;
    if (label !== buttonlabel || enableNewWidget) {
      return (h("pes-cta-button", { class: "cta-area__button", importance: importance, size: EQdsButtonSize.STANDARD, icon: icon, text: label, onDidClick: (e) => onClick(e.detail), "data-autotests-id": dataset === null || dataset === void 0 ? void 0 : dataset.autotestId }));
    }
    props.importance = importance;
    return (h("pes-cta-product-selector", { selectorConfig: this.selectorConfig, isCtaArea: true, buttonProps: props, showProductSelectorStatus: this.showProductSelectorStatus }));
  }
  renderQuickActions() {
    return (h("pes-quick-actions", { class: "cta-area-sticky__quick-actions", showCompare: false, showFavorites: this.showFavorites, hideOnTablet: false, addToMyProductsLabel: this.addToMyProductsLabel, removeFromMyProductsLabel: this.removeFromMyProductsLabel, isInFavorites: this.isInFavorites, isStickyBar: true }));
  }
  render() {
    return (h("div", { class: "cta-area-sticky" }, this.imageUrl && this.imageTitle && (h("div", { class: "cta-area-sticky__img" }, h("pes-lazy-img", { src: this.imageUrl, alt: this.imageTitle }))), h("pes-cta-price", { class: "cta-area-sticky__price", priceFromLabel: this.priceFromLabel, priceHTML: this.priceHTML, tooltipHTML: this.tooltipHTML, variant: "stickyBar" }), h("div", { class: "cta-area-sticky__button" }, this.isUnifiedCheckoutEnabled
      ? h(CtaList, { showCtas: this.showCtas, ctaInfo: this.ctaInfo, itemCtas: this.itemCtas, ctaInfoMapping: this.ctaInfoMapping, handleCtaClick: this.handleCtaClick, productSelectorInfo: this.productSelectorInfo })
      : null, !this.isUnifiedCheckoutEnabled
      ? this.renderButton() || this.renderQuickActions() : null)));
  }
  static get is() { return "pes-cta-area-view-sticky"; }
  static get encapsulation() { return "shadow"; }
  static get originalStyleUrls() {
    return {
      "$": ["pes-cta-area-view-sticky.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["pes-cta-area-view-sticky.css"]
    };
  }
  static get properties() {
    return {
      "imageUrl": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "image-url",
        "reflect": false
      },
      "imageTitle": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "image-title",
        "reflect": false
      },
      "priceHTML": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "price-h-t-m-l",
        "reflect": false
      },
      "tooltipHTML": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "tooltip-h-t-m-l",
        "reflect": false
      },
      "priceFromLabel": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "price-from-label",
        "reflect": false
      },
      "buttons": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "TRenderButtons",
          "resolved": "{ emphasized?: TRenderButtonProps; standard?: TRenderButtonProps[]; }",
          "references": {
            "TRenderButtons": {
              "location": "import",
              "path": "../pes-cta-area-view/types"
            }
          }
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        }
      },
      "addToMyProductsLabel": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "add-to-my-products-label",
        "reflect": false
      },
      "removeFromMyProductsLabel": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "remove-from-my-products-label",
        "reflect": false
      },
      "isInFavorites": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "is-in-favorites",
        "reflect": false,
        "defaultValue": "false"
      },
      "showFavorites": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "show-favorites",
        "reflect": false
      },
      "selectorConfig": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "TScHpcProductSelectorConfig",
          "resolved": "Omit<TScProductSelectorConfig, \"type\"> & Omit<THpcProductSelectorConfig, \"type\"> & { type: \"hpc\" | \"cr\" | \"sc\"; }",
          "references": {
            "TScHpcProductSelectorConfig": {
              "location": "import",
              "path": "@pes-ui/utils"
            }
          }
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        }
      },
      "showProductSelectorStatus": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "TProductSelectorStatus",
          "resolved": "{ loaded: boolean; isExternalState: boolean; state: boolean; }",
          "references": {
            "TProductSelectorStatus": {
              "location": "import",
              "path": "../../../globals/types"
            }
          }
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        }
      },
      "ctaInfo": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "ProductsApi.TCtaInfo",
          "resolved": "{ [key: string]: { type: string; label?: string; primary?: boolean; url?: string; gaAttributes?: TGaAttributes; }; }",
          "references": {
            "ProductsApi": {
              "location": "import",
              "path": "@pes-ui/utils"
            }
          }
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        }
      },
      "ctaInfoMapping": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "{ [key: string]: TCtaInfoMapping }",
          "resolved": "{ [key: string]: TCtaInfoMapping; }",
          "references": {
            "TCtaInfoMapping": {
              "location": "import",
              "path": "../../../globals/types"
            }
          }
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "defaultValue": "{}"
      },
      "showCtas": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "show-ctas",
        "reflect": false
      },
      "itemCtas": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "string[]",
          "resolved": "string[]",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        }
      },
      "handleCtaClick": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "(cta: Values<typeof BUTTON_TYPES>) => void",
          "resolved": "(cta: Values<{ readonly ADD_TO_CART: \"ADD_TO_MY_CART\"; readonly ADD_TO_MYLIST: \"ADD_TO_MY_LIST\"; readonly NOTIFY_ME: \"NOTIFY_ME\"; readonly VIEW_DETAILS: \"VIEW_DETAILS\"; readonly DOWNLOAD_SOFTWARE: \"DOWNLOAD_SOFTWARE\"; readonly VIEW_ONLINE_SOFTWARE: \"VIEW_ONLINE_SOFTWARE\"; readonly SEE_SOFTWARE: \"SEE_SOFTWARE\"; readonly PRODUCT_SELECTOR: \"PRODUCT_SELECTOR\"; }>) => void",
          "references": {
            "Values": {
              "location": "import",
              "path": "@pes-ui/utils"
            }
          }
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        }
      },
      "productSelectorInfo": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "ProductSelectorInfo",
          "resolved": "{ selectorConfig: TScHpcProductSelectorConfig; isCtaArea: boolean; buttonProps?: TRenderButtonProps; showProductSelectorStatus: TProductSelectorStatus; addToMyCartLabel?: string; addToMyListLabel?: string; }",
          "references": {
            "ProductSelectorInfo": {
              "location": "import",
              "path": "../../../globals/types"
            }
          }
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        }
      }
    };
  }
  static get elementRef() { return "el"; }
}
